import styled, { css } from 'styled-components';

import { Flex } from '@/components/Flex';
import LinkWithLocale from '@/components/LinkWithLocale/LinkWithLocale';
import { SectionHeader } from '@/components/SectionHeader';

export const Wrapper = styled(Flex)`
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  margin-bottom: ${({ theme }) => theme.spacing(1)};

  ${({ theme }) => css`
    padding: ${theme.spacing(2)} ${theme.spacing(2)} 12px ${theme.spacing(2)};
    border-top: 1px solid ${theme.colors.mediumGrey};
    border-bottom: 1px solid ${theme.colors.mediumGrey};
    background-color: ${theme.colors.white};

    ${theme.media.md.up} {
      display: none;
    }
  `}
`;

export const HeaderText = styled(SectionHeader)`
  padding: 0;
  margin-bottom: 0;
  font-size: ${({ theme }) => theme.fontSizes.h4};
`;

export const CloseLink = styled(LinkWithLocale)`
  position: absolute;
  background-color: initial;
  right: ${({ theme }) => theme.spacing(3)};
`;
